import React from "react";
import PropTypes from "prop-types";
import { useErrorReporter } from "../../hooks/use-error-reporter";
import { Skeleton } from "@mui/material";

// Wrapper to use hooks with class component
export function ErrorBoundaryWrapper({
  errorMessage = "Render Error",
  fatal = true,
  ...props
}) {
  const { reportError } = useErrorReporter();
  return (
    <ErrorBoundaryInner
      fatal={fatal}
      {...props}
      errorMessage={errorMessage}
      reportError={reportError}
    />
  );
}

ErrorBoundaryWrapper.propTypes = {
  children: PropTypes.node,
  errorMessage: PropTypes.string,
};

class ErrorBoundaryInner extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.props.reportError(
      this.props.errorMessage,
      { error, errorInfo },
      this.props.fatal,
    );
  }

  render() {
    if (this.state.hasError) {
      return <Skeleton variant="rectangular" width="100%" height="100%" />;
    }

    return this.props.children;
  }
}

ErrorBoundaryInner.propTypes = {
  children: PropTypes.node,
  reportError: PropTypes.func.isRequired,
  errorMessage: PropTypes.string.isRequired,
};

export const ErrorBoundary = ErrorBoundaryWrapper;
